import { I18nComponente } from "@/types/gerais"

export const OTabelaMembrosProjetoi18n: I18nComponente = {
  "pt-BR": {
    profissionais: "profissionais",
    emailNaoInformado: "email não informado",
    codigoDoProjeto: "código do projeto",
    salvoComSucesso: "salvo com sucesso",
    codigoEditadoComSucesso: "código editado com sucesso",
  },
  "es-CO": {
    profissionais: "profesionales",
    emailNaoInformado: "correo electrónico no informado",
    codigoDoProjeto: "código del proyecto",
    salvoComSucesso: "guardado con éxito",
    codigoEditadoComSucesso: "código editado con éxito",
  },
}
